import { Icon } from '@/new/components/icon';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/new/components/shadcn/dialog';

export function DeduplicationInfoDialog() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="text-gray-400 hover:text-gray-600">
          <Icon className="lucide--info h-4 w-4" />
        </button>
      </DialogTrigger>
      <DialogContent className="overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Include Deduplicated Documents</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm text-gray-600">
          <p>
            When enabled, documents that were marked as duplicates during the processing run will be included in the
            Subset. This is useful when you want a Subset to contain all documents from a particular upload (e.g.
            uploading the Defendant's disclosure).
          </p>
          <div className="overflow-hidden rounded-lg border">
            <table className="w-full text-left text-xs">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-3 py-2 font-medium text-gray-500">Document</th>
                  <th className="px-3 py-2 font-medium text-gray-500"></th>
                </tr>
              </thead>
              <tbody className="divide-y">
                <tr className="bg-amber-50/50">
                  <td className="px-3 py-2 text-gray-700">
                    Contract.pdf
                    <span className="ml-2 shrink-0 rounded bg-amber-100 px-1.5 py-0.5 text-xs text-amber-700">
                      Duplicate
                    </span>
                  </td>
                  <td className="flex items-center gap-2 px-3 py-2 text-gray-700">
                    Deduplicated document of a previous run
                  </td>
                </tr>
                <tr>
                  <td className="px-3 py-2 text-gray-700">Email_thread.msg</td>
                  <td className="flex items-center gap-2 px-3 py-2 text-gray-700">Unique in selected run</td>
                </tr>
                <tr>
                  <td className="px-3 py-2 text-gray-700">New_Contract.pdf</td>
                  <td className="flex items-center gap-2 px-3 py-2 text-gray-700">Unique in selected run</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
